import React from 'react';
import StaticKeyMetricCard from './StaticKeyMetricCard';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { formatMetric } from 'src/utils/app';
import { useConversionV2ChartData } from 'src/components/AtlasV2Components/AtlasV2ConversionPageComponents/AtlasV2ConversionSplineV2Chart';

interface ConversionCardProps {
  variant: 'large' | 'small' | 'medium';
  indexName: string;
  fieldName: string;
  title: string;
  onClick?: () => void;
}

const ConversionCard = ({ fieldName, indexName, variant, title, onClick }: ConversionCardProps) => {
  const { primarySeries, secondarySeries, primaryDerivedMetricAverage, primaryDerivedMetricPercentChange, loading } =
    useConversionV2ChartData();

  const mainMetric = formatMetric(primaryDerivedMetricAverage, METRICTYPE.PERCENT, {
    showFullValue: true,
    decimalPlaces: 2
  });

  return (
    <StaticKeyMetricCard
      variant={variant}
      indexName={indexName}
      fieldName={fieldName}
      title={title}
      onClick={onClick}
      isLoading={loading}
      primaryData={primarySeries}
      secondaryData={secondarySeries}
      formattedPrimaryTotal={mainMetric}
      percentChange={primaryDerivedMetricPercentChange}
      formattedPercentChange={formatMetric(Math.abs(primaryDerivedMetricPercentChange), METRICTYPE.PERCENT, {
        showFullValue: true,
        decimalPlaces: 2
      })}
    />
  );
};

export default ConversionCard;
